import { render, staticRenderFns } from "./UploadArquivos.vue?vue&type=template&id=7326749a&"
import script from "./UploadArquivos.vue?vue&type=script&lang=js&"
export * from "./UploadArquivos.vue?vue&type=script&lang=js&"
import style0 from "./UploadArquivos.vue?vue&type=style&index=0&id=7326749a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports